import { VocabularyPage } from './VocabularyPage';
export default VocabularyPage;
